import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Film } from "lucide-react";
import { api } from "@/lib/api";
import { DURATION, STYLE, FORMAT, STAGES, egp, fmtDate, cardCls, orderLabel } from "@/lib/labels";
import { StageBar } from "./StageTracker";

export const OrderSummaryLine = ({ o }) => (
  <p className="text-sm text-purple-200/80">{DURATION[o.duration]} · {STYLE[o.style]} · {FORMAT[o.format]}</p>
);

export const OrdersList = ({ tick }) => {
  const [orders, setOrders] = useState(null);
  useEffect(() => {
    api.get("/customer/orders").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  }, [tick]);

  if (orders === null) return <p className="text-purple-300/70">بنحمّل...</p>;
  if (!orders.length) {
    return (
      <div className="rounded-3xl border-2 border-dashed border-purple-500/30 p-10 text-center" data-testid="orders-empty">
        <Film className="mx-auto mb-3 h-12 w-12 text-[var(--km-purple)]" />
        <p className="font-head text-lg text-white">لسه ماطلبتش إعلانات</p>
        <Link to="/create-ad" className="font-head mt-4 inline-flex rounded-full bg-[var(--km-pink)] px-5 py-2.5 font-bold text-white" data-testid="orders-empty-create-btn">اعمل إعلانك</Link>
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="orders-list">
      {orders.map((o, i) => (
        <Link key={o.id} to={`/account/orders/${o.id}`} className={`${cardCls} block p-5 transition-[transform,border-color] hover:-translate-y-0.5 hover:border-[var(--km-pink)]`} data-testid={`order-card-${i}`}>
          <div className="mb-2 flex flex-wrap items-start justify-between gap-2">
            <div>
              <p className="font-head text-lg font-bold text-white" data-testid={`order-label-${i}`}>{orderLabel(o)} {o.is_free && <span className="mr-2 rounded-full bg-[var(--km-cyan)] px-2 py-0.5 text-xs text-[#0b0414]">مجاني</span>}</p>
              <OrderSummaryLine o={o} />
            </div>
            <div className="text-left">
              <p className="font-head font-bold text-white">{o.is_free ? "مجاني" : egp(o.price)}</p>
              <p className="text-xs text-purple-300/60">{fmtDate(o.created_at)}</p>
            </div>
          </div>
          <p className={`font-head mb-2 text-sm font-bold ${o.status === "cancelled" ? "text-red-300" : "text-[var(--km-cyan)]"}`} data-testid={`order-stage-${i}`}>
            {o.status === "cancelled" ? "ملغي" : STAGES[o.stage]}
          </p>
          <StageBar stage={o.stage} cancelled={o.status === "cancelled"} />
        </Link>
      ))}
    </div>
  );
};
